import cx from 'classnames';
import { MDText } from 'i18n-react';

import type { VehicleData } from 'Pages/vehicles/helpers/vehicle.schema';
import { applyCypressData, applyTestIdData } from 'Utilities/helpers';

import cypressIds from '../cypress_ids.json';
import texts from '../texts.json';

import styles from './NumericGradingText.module.scss';

const LocalT = new MDText(texts);

export const NumericGradingText: React.FC<{
	grade: VehicleData['ratings']['numericGrade'];
	size: 'regular' | 'large';
}> = ({ grade, size }) => {
	return (
		<div
			className={cx(styles.container, size === 'large' && styles.large)}
			{...applyTestIdData(cypressIds.containers.numericGradingText)}
			{...applyCypressData(cypressIds.containers.numericGradingText)}
		>
			{grade ? (
				<>
					<span>{LocalT.translate(`vehicleList.filters.numericGrades.grade`)}</span>
					<div
						className={cx([
							styles.numericGradeNumberContainer,
							styles[`grade-${grade}`],
							size === 'large' && styles.large,
						])}
					>
						<span>{LocalT.translate(`vehicleList.filters.numericGrades.grade-${grade}`)}</span>
					</div>
				</>
			) : (
				<span>-</span>
			)}
		</div>
	);
};
